import { ApiRequestError } from '../../api/auth.ts';
import { Banner } from '../../components/ui.tsx';
import { t } from '../../i18n/index.ts';

export function CommandError({ error }: { error: unknown }) {
  const message =
    error instanceof ApiRequestError
      ? error.code === 'forbidden'
        ? t('common.noPermission')
        : error.message
      : t('common.error');
  return <Banner tone="danger" title={message} />;
}
